import { useSkippableQuery } from '../../useSkippableQuery';
import { useUser } from '../../useUser';
import { ADDRESSES_QUERY } from './addressesQuery.rest';

type UseAddressesQueryOptions = {
  skip?: boolean;
};

export const useAddressesQuery = (options?: UseAddressesQueryOptions) => {
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error } = useSkippableQuery(ADDRESSES_QUERY, {
    skip: !accessToken || options?.skip
  });

  return { addresses: data?.addresses.data || [], fetched: data != null, loading, error };
};
